module.exports = __webpack_public_path__ + "static/CollectiveRooftopTerrace-min-59196cf64ddd782c21db273156ec4d75.jpg";